import { MutationHookOptions, gql } from '@apollo/client';

import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

const queryType = 'CANCEL_POLICY';

const useCancelPolicyMutation = (options: MutationHookOptions = {}) => {
  const queryName = useEdeQueryName(queryType);

  const CANCEL_POLICY_MUTATION = gql`
    mutation CancelPolicy($appID: ID!, $payload: CancelPolicyInput) {
      ${queryName} (appID: $appID, payload: $payload) {
        success
        action
        data
      }
    }
  `;

  return useEdeMutation(CANCEL_POLICY_MUTATION, options);
};

export default useCancelPolicyMutation;
